import AbstractPeriodColumnTemplateSource from "./AbstractPeriodColumnTemplateSource.js";
import ForecastEstimatePeriodColumnSource from "../../../reports/columns/periodColumnSource/ForecastEstimatePeriodColumnSource.js";

/**
 * This class is used when a period column should fetch data from a
 *   Forecast Estimate.
 */
export default class ForecastEstimatePeriodColumnTemplateSource extends AbstractPeriodColumnTemplateSource {
	constructor({ forecastEstimateId }) {
		super(...arguments);

		this._forecastEstimateId = forecastEstimateId;
	}

	isForecastEstimateSource() {
		return true;
	}

	_instanceClass() {
		return ForecastEstimatePeriodColumnSource;
	}

	_interpretationSpec() {
		return {
			...super._interpretationSpec(...arguments),
			forecastEstimateId: this._forecastEstimateId,
		};
	}
}
